module.exports = __webpack_public_path__ + "static/img/patternIcon8.2d60680.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile_images/patternIcon8.png
// module id = i+wN
// module chunks = 1